// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyA4pVggqAL7Wi4hpfPv_-7rXA449vhECd8",
    authDomain: "test-d0430.firebaseapp.com",
    databaseURL: "https://test-d0430.firebaseio.com",
    projectId: "test-d0430",
    storageBucket: "test-d0430.appspot.com",
    messagingSenderId: "1005401973665"
  }
};


//original key to Ikewai.dst
// export const environment = {
//   production: false,
//   firebase: {
//     apiKey: 'AIzaSyAhu7oynhl6bfTFj0tdYJKXY2PbqdAWizk',
//     authDomain: 'ikewaidst-9d7ff.firebaseapp.com',
//     databaseURL: 'https://ikewaidst-9d7ff.firebaseio.com',
//     projectId: "ikewaidst-9d7ff",
//     storageBucket: "ikewaidst-9d7ff.appspot.com",
//     messagingSenderId: "769410091280"
//   }
// };
